import type { NestedUser, Scope, SignedInCompany } from '@revelate/types';
import { commissionCopy } from '@revelate/constants/commission-copy';

import type { CommissionAccess } from "@revelate/types";
export type { CommissionAccess } from "@revelate/types";

export { commissionCopy } from "@revelate/constants/commission-copy";

export class CommissionAccessError extends Error {
  readonly retryable: boolean;

  constructor(error: { code?: string }) {
    const setupRequired = error.code === 'PGRST202' || error.code === '42883';
    const accessDenied = error.code === '42501';
    super(setupRequired ? commissionCopy.setupRequired : accessDenied ? commissionCopy.accessDenied : commissionCopy.accessFailed);
    this.retryable = !setupRequired && !accessDenied;
  }
}

export function commissionUsersForScope(company: SignedInCompany, scope: Scope | null | undefined, access: CommissionAccess | undefined): NestedUser[] {
  if (!access) return [];
  const allowed = new Set(access.user_ids);
  const selected = scope?.type === 'user' ? new Set([scope.value])
    : scope?.type === 'team' ? new Set(access.teams.find(t => String(t.id) === scope.value)?.user_ids ?? [])
    : allowed;
  return company.users.filter(u => u.include_in_calculations && allowed.has(u.id) && selected.has(u.id)) as NestedUser[];
}

export function canApproveCommission(access: CommissionAccess | undefined, userId: string, final = false) {
  return !!access && (final ? ['admin', 'super_admin'].includes(access.role) && access.user_ids.includes(userId)
    : access.first_approval_user_ids.includes(userId));
}
